// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hover-card[class*=border-][data-v-02ba3f1d]:not(:hover){border-color:transparent!important}", ""]);
// Exports
module.exports = exports;
